import { differenceInMinutes } from "date-fns";

/**
 * Calculates the minutes elapsed between reference date and target date.
 * If the target date is in the future, returns 0.
 */
export function calculateMinutesElapsed(targetDate: Date, referenceDate: Date): number {
  return Math.max(differenceInMinutes(referenceDate, targetDate), 0);
}
